<script setup lang="ts">
import Seat from '@/components/svg/Seat'
import formatCurrency from '@/utils/formatCurrency'

export default {
  components: { Seat },
  props: {
		from: { type: String, required: true },
		to: { type: String, required: true },
		aircraft: { type: String, required: true },
		minutes: { type: Number, required: true },
		perSeat: { type: Number, required: true },
  },
  methods: {
    formatCurrency,
  },
}
</script>

<template>
	<div
		class="flex flex-col text-center md:text-left"
		style="min-width: 128px;"
	>
		<span class="text-black text-base font-medium leading-tight">{{ from }} > {{ to }}</span>
		<span class="mt-5 text-grey-700 text-base leading-tight tracking-widest uppercase">{{ aircraft }}</span>
		<span class="mt-1 text-grey-700 font-inter text-base leading-tight">{{ minutes }} minutes flight</span>
		<span class="mt-1 text-grey-700 text-base leading-tight">
			<span class="font-inter">{{ formatCurrency(perSeat) }} / 1</span>
			&nbsp;<Seat class="mb-1 inline h-4 w-4 flex-shrink-0" />
		</span>
	</div>
</template>
